<script lang="ts">
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Typography from "../Typography.svelte";
  import Edit from "../../assets/icons/edit.svg";

  export let headerCopy: string;
  export let onEditClick: () => void;
  export let hideEditButton = false;
</script>

<div class="card flex flex-col w-full p-6 pt-4 items-start gap-4 rounded-2xl relative">
  {#if !hideEditButton}
    <button
      class="edit-button flex items-center justify-center w-8 h-8 gap-2 absolute top-4 right-4 rounded-lg pointer"
      on:click={onEditClick}>
      <img src={Edit} alt="Edit" />
    </button>
  {/if}
  <div class="flex items-start gap-6 self-stretch">
    <Typography mobile={TypographyType.Headline3} desktop={TypographyType.Headline1} copy={headerCopy} />
  </div>
  <slot name="card items" />
  <slot name="card body" />
</div>

<style>
  .edit-button {
    background-color: var(--color-grayscale-20);
  }

  .card {
    border: 1px solid var(--color-grayscale-30);

    /* Elevation 2 */
    box-shadow: 0px 0px 4px 0px rgba(112, 126, 150, 0.04), 0px 8px 16px 0px rgba(112, 126, 150, 0.08);
  }
</style>
